<template>
  <div id="user-form">
    <p v-if="errors.length">
      <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
      <ul>
        <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
      </ul>
    </p>
    <h3 v-if="!esRegistroUsuario"> Datos Solicitante</h3>
    <div v-if="esSegundoPedido" class="form-group">
      <label for="nroPedido">N° Pedido (al cual desea adjuntar)</label>
      <input type="text" class="form-control" id="nroPedido" placeholder="Nro pedido"  v-model="$v.usuario.nroPedido.$model"
        :class="status($v.usuario.nroPedido)">
    </div>
    <div class="form-group">
      <label for="nombre">Nombre</label>
      <input type="text" class="form-control" id="nombre" placeholder="Nombre"  v-model="$v.usuario.nombre.$model"
        :class="status($v.usuario.nombre)">
    </div>
    <div class="form-group">
      <label v-if="esEnvioStarken" for="apellido">Apellido Paterno</label>
      <label v-else for="apellido">Apellidos</label>
      <input type="text" class="form-control" id="apellido" placeholder="Apellido" v-model="$v.usuario.apellido.$model"
        :class="status($v.usuario.apellido)">
    </div>
    <div v-if="esEnvioStarken" class="form-group">
      <label for="apellidoMaterno">Apellido Materno</label>
      <input type="text" class="form-control" id="apellidoMaterno" placeholder="Apellido Materno"  v-model="$v.usuario.apellidoMaterno.$model"
        :class="status($v.usuario.apellidoMaterno)">
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="email"
        class="form-control"
        id="email"
        aria-describedby="emailHelp"
        placeholder="Ingrese Email"
        v-model="$v.usuario.email.$model"
        :class="status($v.usuario.email)"
      />
    </div>
    <div class="form-group">
      <label for="telefono">Teléfono</label>
      <input type="number" class="form-control" id="telefono" placeholder="Teléfono" v-model="$v.usuario.telefono.$model"
        :class="status($v.usuario.telefono)">
    </div>
    <div v-if="esSegundoPedido || esRetiroDomicilio" class="form-group">
      <label for="comentario">Comentario</label>
      <div v-if="esSegundoPedido">
        <input type="text" class="form-control" id="comentario" placeholder="Si adjunta pedido con otra persona indicar el nombre acá" v-model="$v.usuario.referencia.$model"
          :class="status($v.usuario.referencia)">
      </div>
      <div v-else>
        <input type="text" class="form-control" id="comentario" placeholder="" v-model="$v.usuario.referencia.$model"
          :class="status($v.usuario.referencia)">
      </div>
    </div>
    <div v-if="esRetiroDomicilio" class="form-group">
      <p>
        <b>El retiro se realiza en el domicilio ubicado en Eleodoro Rodriguez Matte 033, Maipú. Santiago. </b><br />
        <b>El horario para retiro es de 10 a 20 hrs de lunes a viernes. Previa coordinación.</b></p>
    </div>
    <div v-if="!esSegundoPedido && !esRetiroDomicilio" >
      <h3 v-if="!esRegistroUsuario"> Datos de envío</h3>
      <div class="form-group">
        <label for="calle">Calle</label>
        <input type="text" class="form-control" id="calle" placeholder="Calle" v-model="$v.usuario.calle.$model"
          :class="status($v.usuario.calle)">
      </div>
      <div class="form-group">
        <label for="numero">Número</label>
        <input type="number" class="form-control" id="numero" placeholder="Número" v-model="$v.usuario.numero.$model"
          :class="status($v.usuario.numero)">
      </div>
      <div class="form-group">
        <label for="departamento">Departamento</label>
        <input type="text" class="form-control" id="departamento" placeholder="Departamento" v-model="$v.usuario.departamento.$model"
          :class="status($v.usuario.departamento)">
      </div>
      <div v-if="!esRegistroUsuario"  class="form-group">
        <label for="referencia">Referencia (Opcional)</label>
        <input type="text" class="form-control" id="referencia" placeholder="Referencia" v-model="$v.usuario.referencia.$model"
          :class="status($v.usuario.referencia)">
      </div>
      <div class="form-group">
        <label for="comuna">Comuna</label>
        <input type="text" class="form-control" id="comuna" placeholder="Comuna" v-model="$v.usuario.comuna.$model"
          :class="status($v.usuario.comuna)">
      </div>
      <div class="form-group">
        <label for="region">Región</label>
        <input type="text" :disabled="esEnvioRM" class="form-control" id="region" placeholder="Región" v-model="$v.usuario.region.$model"
          :class="status($v.usuario.region)">
      </div>
      <div v-if="!esRegistroUsuario && esEnvioStarken" class="form-group">
        <label for="rut">RUT (Sólo para envíos por Starken)</label>
        <input type="text" class="form-control" id="rut" placeholder="ej 12345678-9" v-model="$v.usuario.rut.$model"
          :class="status($v.usuario.rut)">
      </div>
      <div v-if="esRegistroUsuario" class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <input
          type="password"
          class="form-control"
          id="password"
          placeholder="Password"
          v-model="$v.usuario.password.$model"
          :class="status($v.usuario.password)"
        />
      </div>
      <div v-if="esRegistroUsuario" class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <input
          type="password"
          class="form-control"
          id="rePassword"
          placeholder="Repetir Password"
          v-model="$v.usuario.rePassword.$model"
          :class="status($v.usuario.rePassword)"
        />
      </div>
    </div>
    <button v-if="esRegistroUsuario" @click="registrarUsuario()" :disabled="btnDisabled" class="btn btn-primary float-right">Crear Cuenta</button>
    <button v-else @click="continuar()" :disabled="btnDisabled" class="btn btn-primary float-right">Continuar</button>
    <br />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { required, minLength, maxLength, email, sameAs, numeric } from 'vuelidate/lib/validators'
import { store } from '@/store/storeBuscador'

export default {
  name: 'FormularioUsuario',
  beforeCreate () {
    this.$store.state.modoCompra = true
  },
  beforeDestroy () {
    this.$store.state.modoCompra = false
  },
  data () {
    return {
      usuario: {
        nroPedido: '',
        email: '',
        nombre: '',
        apellido: '',
        apellidoMaterno: '',
        calle: '',
        numero: '',
        departamento: '',
        comuna: '',
        region: '',
        telefono: '',
        password: '',
        rePassword: '',
        rut: '',
        referencia: '',
        comentario: ''
      },
      errors: [],
      btnDisabled: false,
      esEnvioRM: false,
      esEnvioStarken: false,
      esSegundoPedido: false,
      esRetiroDomicilio: false
    }
  },
  validations: {
    usuario: {
      nroPedido: {
        required,
        maxLength: maxLength(11)
      },
      email: {
        required,
        email,
        minLength: minLength(6),
        maxLength: maxLength(100)
      },
      nombre: {
        required,
        maxLength: maxLength(50)
      },
      apellido: {
        required,
        maxLength: maxLength(50)
      },
      apellidoMaterno: {
        required,
        maxLength: maxLength(50)
      },
      calle: {
        required,
        maxLength: maxLength(100)
      },
      numero: {
        required,
        numeric,
        maxLength: maxLength(25)
      },
      departamento: {
        maxLength: maxLength(25)
      },
      comuna: {
        required,
        maxLength: maxLength(150)
      },
      region: {
        required,
        maxLength: maxLength(150)
      },
      telefono: {
        required,
        maxLength: maxLength(12),
        numeric
      },
      password: {
        required,
        minLength: minLength(6)
      },
      rePassword: {
        sameAsPassword: sameAs('password')
      },
      rut: {
        maxLength: maxLength(10),
        minLength: minLength(9)
      },
      referencia: {
        maxLength: maxLength(150)
      }

    }
  },
  mounted () {
    if (this.loggedIn && this.esRegistroUsuario) {
      this.$router.push('/')
    } else if (!this.esRegistroUsuario) {
      if (this.loggedIn) {
        console.log('usuarioLogeado: ', this.usuarioLogeado)
        this.usuario.region = this.usuarioLogeado.region
        this.usuario.email = this.usuarioLogeado.email
        this.usuario.nombre = this.usuarioLogeado.nombre
        this.usuario.apellido = this.usuarioLogeado.apellido
        this.usuario.direccion = this.usuarioLogeado.direccion
        this.usuario.telefono = this.usuarioLogeado.telefono
        this.usuario.comuna = this.usuarioLogeado.comuna
      }
      this.esEnvioRM = false
      this.esEnvioStarken = false
      this.esSegundoPedido = false
      this.esRetiroDomicilio = false
      if (this.carro.envio.id === 1) {
        this.usuario.region = 'Región Metropolitana Urbana'
        this.esEnvioRM = true
      } else if (this.carro.envio.id === 2) {
        this.esEnvioStarken = true
      } else if (this.carro.envio.id === 3) {
        this.esSegundoPedido = true
      } else if (this.carro.envio.id === 4) {
        this.esRetiroDomicilio = true
      }
    }
  },
  methods: {
    ...mapMutations(['confirmarComprar']),
    continuar () {
      this.btnDisabled = true
      if (this.check()) {
        this.seteoCamposEspecifico()
        this.confirmarComprar(this.usuario)
      } else {
        this.btnDisabled = false
      }
    },
    registrarUsuario () {
      this.btnDisabled = true
      if (this.check()) {
        try {
          const reqUsuario = {}
          reqUsuario.email = this.usuario.email
          reqUsuario.nombre = this.usuario.nombre
          reqUsuario.apellido = this.usuario.apellido
          reqUsuario.direccion = this.usuario.calle + ' ' + this.usuario.numero
          if (this.usuario.departamento) {
            reqUsuario.direccion = reqUsuario.direccion + ' ' + this.usuario.departamento
          }
          reqUsuario.comuna = this.usuario.comuna
          reqUsuario.region = this.usuario.region
          reqUsuario.telefono = this.usuario.telefono
          reqUsuario.password = this.usuario.password
          reqUsuario.idRol = 2
          this.$store.dispatch('auth/register', reqUsuario)
            .then(() => {
              this.$router.push({ name: 'Login' })
            })
            .catch(() => {
              this.$router.push({ name: 'Error' })
            })
        } catch (error) {
          this.$router.push({ name: 'Error' })
        }
      } else {
        this.btnDisabled = false
      }
    },
    check () {
      this.errors = []
      this.$v.$touch()
      const envioEsStarken = this.carro.envio.id === 2
      const envioEsSegundoPedido = this.carro.envio.id === 3
      const envioEsRetiroDomicilio = this.carro.envio.id === 4
      if (!this.$v.usuario.email.required) {
        this.errors.push('Debe ingresar un email')
      } else if (!this.$v.usuario.email.minLength) {
        this.errors.push('El email debe tener como mínimo 6 caracteres')
      } else if (!this.$v.usuario.email.maxLength) {
        this.errors.push('El email debe tener como máximo 100 caracteres')
      } else if (!this.$v.usuario.email.email) {
        this.errors.push('Ingrese un email es válido')
      }

      if (envioEsSegundoPedido) {
        if (!this.$v.usuario.nroPedido.required) {
          this.errors.push('Debe ingresar un número de pedido')
        } else if (!this.$v.usuario.nroPedido.maxLength) {
          this.errors.push('El número de pedido debe tener como máximo 11 caracteres')
        }
      }

      if (!this.$v.usuario.nombre.required) {
        this.errors.push('Debe ingresar un nombre')
      } else if (!this.$v.usuario.nombre.maxLength) {
        this.errors.push('El nombre debe tener como máximo 50 caracteres')
      }

      if (!this.$v.usuario.apellido.required) {
        this.errors.push('Debe ingresar un apellido')
      } else if (!this.$v.usuario.nombre.maxLength) {
        this.errors.push('El apellido debe tener como máximo 50 caracteres')
      }

      if (!this.$v.usuario.telefono.required) {
        this.errors.push('Debe ingresar un telefono')
      } else if (!this.$v.usuario.telefono.maxLength) {
        this.errors.push('El telefono debe tener como máximo 12 caracteres')
      } else if (!this.$v.usuario.telefono.numeric) {
        this.errors.push('El telefono debe contener solo numeros')
      }

      if (envioEsStarken) {
        if (!this.$v.usuario.apellidoMaterno.required) {
          this.errors.push('Debe ingresar un apellido materno')
        } else if (!this.$v.usuario.apellidoMaterno.maxLength) {
          this.errors.push('El apellido materno debe tener como máximo 50 caracteres')
        }
      }

      if (!envioEsSegundoPedido) {
        if (!envioEsRetiroDomicilio) {
          if (!this.$v.usuario.calle.required) {
            this.errors.push('Debe ingresar una calle')
          } else if (!this.$v.usuario.calle.maxLength) {
            this.errors.push('La calle debe tener como máximo 100 caracteres')
          }

          if (!this.$v.usuario.numero.required) {
            this.errors.push('Debe ingresar un número')
          } else if (!this.$v.usuario.numero.maxLength) {
            this.errors.push('La número debe tener como máximo 25 caracteres')
          }

          if (!this.$v.usuario.comuna.required) {
            this.errors.push('Debe ingresar una comuna')
          } else if (!this.$v.usuario.comuna.maxLength) {
            this.errors.push('La comuna debe tener como máximo 150 caracteres')
          }

          if (!this.$v.usuario.region.required) {
            this.errors.push('Debe ingresar una región')
          } else if (!this.$v.usuario.region.maxLength) {
            this.errors.push('La región debe tener como máximo 150 caracteres')
          }
        }

        if (!this.$v.usuario.departamento.maxLength) {
          this.errors.push('La departamento debe tener como máximo 25 caracteres')
        }
      }

      if (this.esRegistroUsuario) {
        if (!this.$v.usuario.password.required) {
          this.errors.push('Debe ingresar una password')
        } else if (!this.$v.usuario.password.minLength) {
          this.errors.push('Su password debe contener como mínimo 6 caracteres')
        }
        if (!this.$v.usuario.rePassword.sameAsPassword) {
          this.errors.push('Debe repetir su password de forma correcta')
        }
      } else {
        if (!this.$v.usuario.referencia.maxLength) {
          this.errors.push('La referencia debe tener como máximo 150 caracteres')
        }

        if (envioEsStarken && !this.usuario.rut) {
          this.errors.push('El rut es obligatorio para envios mediante STARKEN')
        } else if (envioEsStarken && !this.validaRut(this.usuario.rut)) {
          this.errors.push('Ingrese un rut válido')
        }

        if (!this.$v.usuario.rut.maxLength) {
          this.errors.push('el rut debe tener como máximo 10 caracteres')
        } else if (!this.$v.usuario.rut.minLength) {
          this.errors.push('El rut debe tener como mínimo 9 caracteres')
        }
      }

      if (this.errors.length) {
        return false
      } else {
        return true
      }
    },
    validaRut (rutCompleto) {
      rutCompleto = rutCompleto.replace('‐', '-')
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) {
        return false
      }
      var tmp = rutCompleto.split('-')
      var digv = tmp[1]
      var rut = tmp[0]
      if (digv === 'K') {
        digv = 'k'
      }
      return this.dv(rut) === digv
    },
    dv (T) {
      var M = 0
      var S = 1
      for (; T; T = Math.floor(T / 10)) {
        S = (S + T % 10 * (9 - M++ % 6)) % 11
      }
      return S ? (S - 1).toString() : 'k'
    },
    status (validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    seteoCamposEspecifico () {
      const envioEsStarken = this.carro.envio.id === 2
      const envioEsSegundoPedido = this.carro.envio.id === 3
      const envioEsRetiroDomicilio = this.carro.envio.id === 4
      if (envioEsStarken) {
        if (this.usuario.apellidoMaterno) {
          this.usuario.apellido = this.usuario.apellido + ' ' + this.usuario.apellidoMaterno
        }
      }
      if (envioEsSegundoPedido || envioEsRetiroDomicilio) {
        if (this.usuario.telefono === '') {
          this.usuario.telefono = '0'
        }
        if (this.usuario.calle === '') {
          this.usuario.calle = '-'
        }
        if (this.usuario.numero === '') {
          this.usuario.numero = '0'
        }
        if (this.usuario.departamento === '') {
          this.usuario.departamento = ''
        }
        if (this.usuario.comuna === '') {
          this.usuario.comuna = '-'
        }
        if (this.usuario.region === '') {
          this.usuario.region = '-'
        }
        if (envioEsSegundoPedido) {
          if (this.usuario.referencia === '') {
            this.usuario.referencia = 'Nro. Pedido: ' + this.usuario.nroPedido
          } else {
            this.usuario.referencia = 'Nro. Pedido: ' + this.usuario.nroPedido + ' - ' + this.usuario.referencia
          }
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.name === 'RegistrarCuenta') {
      store.state.esRegistroUsuario = true
      next()
    } else if (to.name === 'FormularioUsuario') {
      store.state.esRegistroUsuario = false
      next()
    }
  },
  computed: {
    ...mapState({
      esRegistroUsuario: state => state.esRegistroUsuario,
      loggedIn: state => state.auth.status.loggedIn,
      carro: state => state.carro,
      usuarioLogeado: state => state.auth.usuario
    })
  }
}
</script>
<style scoped>
#user-form {
  margin-bottom: 2rem !important;
  margin-top: 2rem !important;
  margin-left: 6.5rem !important;
  margin-right: 6.5rem !important;
}

@media screen and (max-width: 500px) {
  #user-form {
    margin-bottom: 2rem !important;
    margin-top: 2rem !important;
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
}
</style>
